// Central upload config for user images

// You can adjust this path as per your backend static file serving
export const UPLOAD_BASE_PATH = "/uploads/user-photos";
